/* eslint-disable */
import {
  Autocomplete,
  Button,
  Chip,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import SearchIcon from "@mui/icons-material/Search";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import { Box } from "@mui/system";
import { DataGrid } from "@mui/x-data-grid";
import { useEffect, useState, useContext } from "react";
import { getArmazones } from "../../services/ArmazonService";
import Message from "../../utils/Message";
import { Add } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { getCacheData } from "../../services/CacheService";
import { limpiaCodigo } from "../../utils/utils";
import WaitingDialog from "../../utils/WaitingDialog";
import AuthContext from "../../contexts/AuthContext";

const initialSearchData = {
  codigo: "",
  idArAsMarca: null,
  modelo: "",
  codigoExterno: "",
  descripcion: "",
  idArAsCategoria: null,
  idArAsMaterial: null,
  idArAsFormato: null,
  idArAsCalibre: null,
  idArAsTipo: null,
  idAsColorLente: null,
  colorList: null,
  estado: "habilitado",
};

const estadoOptions = [
  {
    id: "todo",
    descripcion: "Todo",
  },
  {
    id: "habilitado",
    descripcion: "Habilitado",
  },
  {
    id: "deshabilitado",
    descripcion: "Deshabilitado",
  },
];

const nameItemsText = "Armazones";
//
// ############################################################################# 
//
const ArmazonTable = () => {
  const [searchData, setSearchData] = useState(initialSearchData);
  const [itemsCrud, setItemsCrud] = useState([]);
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [totalRowsCount, setTotalRowsCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);
  const [arAsMarcas, setArAsMarcas] = useState([]);
  const [arAsCategorias, setArAsCategorias] = useState([]);
  const [arAsMateriales, setArAsMateriales] = useState([]);
  const [arAsFormatos, setArAsFormatos] = useState([]);
  const [arAsCalibres, setArAsCalibres] = useState([]);
  const [arAsTipos, setArAsTipos] = useState([]);
  const [arAsColores, setArAsColores] = useState([]);
  const navigate = useNavigate();
  const [valueACArAsMarca, setValueACArAsMarca] = useState(null);
  const [inputValueACArAsMarca, setInputValueACArAsMarca] = useState("");
  const [valueACArAsCategoria, setValueACArAsCategoria] = useState(null);
  const [inputValueACArAsCategoria, setInputValueACArAsCategoria] = useState("");
  const [valueACArAsMaterial, setValueACArAsMaterial] = useState(null);
  const [inputValueACArAsMaterial, setInputValueACArAsMaterial] = useState("");
  const [valueACArAsFormato, setValueACArAsFormato] = useState(null);
  const [inputValueACArAsFormato, setInputValueACArAsFormato] = useState("");
  const [valueACArAsCalibre, setValueACArAsCalibre] = useState(null);
  const [inputValueACArAsCalibre, setInputValueACArAsCalibre] = useState("");
  const [valueACArAsTipo, setValueACArAsTipo] = useState(null);
  const [inputValueACArAsTipo, setInputValueACArAsTipo] = useState("");
  const [valueACArAsColor, setValueACArAsColor] = useState([]);
  const [inputValueACArAsColor, setInputValueACArAsColor] = useState("");

  const { hasPermission } = useContext(AuthContext);
  const _crearArmazon = hasPermission("armazon-c");
  const _editarArmazon = hasPermission("armazon-e");
  const _habilitarArmazon = hasPermission("armazon-h");
  const _deshabilitarArmazon = hasPermission("armazon-d");

  const tableColumns = [
    {
      field: "codigo",
      headerName: "Código",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.codigo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "descripcion_ar_as_marca",
      headerName: "Marca",
      headerAlign: "center",
      align: "left",
      flex: 2,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_ar_as_marca;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "modelo",
      headerName: "Modelo",
      headerAlign: "center",
      align: "left",
      flex: 2,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.modelo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "descripcion_ar_as_categoria",
      headerName: "Categoria",
      headerAlign: "center",
      align: "left",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_ar_as_categoria;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "descripcion_ar_as_material",
      headerName: "Material",
      headerAlign: "center",
      align: "left",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_ar_as_material;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "descripcion_ar_as_formato",
      headerName: "Formato",
      headerAlign: "center",
      align: "left",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_ar_as_formato;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "descripcion_ar_as_tipo",
      headerName: "Tipo",
      headerAlign: "center",
      align: "left",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_ar_as_tipo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "habilitado",
      headerName: "Habilitado",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.habilitado ? "SI" : "";
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "actions",
      headerName: "Acciones",
      headerAlign: "center",
      align: "left",
      flex: 1,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <>
          {params.row.habilitado && _editarArmazon && (
            <Tooltip title="editar">
              <IconButton
                size="small"
                aria-label="update"
                onClick={() =>
                  handleClickActionCrud(params.row, "update")
                }
              >
                <EditOutlinedIcon />
              </IconButton>
            </Tooltip>
          )}

          {params.row.habilitado && _deshabilitarArmazon && (
            <Tooltip title="deshabilitar">
              <IconButton
                size="small"
                aria-label="disable"
                onClick={() =>
                  handleClickActionCrud(params.row, "disable")
                }
              >
                <RemoveCircleOutlineIcon />
              </IconButton>
            </Tooltip>
          )}

          {!params.row.habilitado && _habilitarArmazon && (
            <Tooltip title="habilitar">
              <IconButton
                size="small"
                aria-label="enable"
                onClick={() =>
                  handleClickActionCrud(params.row, "enable")
                }
              >
                <AddCircleOutlineOutlinedIcon />
              </IconButton>
            </Tooltip>
          )}
        </>
      ),
    },
  ];

  const handlePaginationModelChange = (newModel) => {
    setCurrentPage(newModel.page);
    setRowsPerPage(newModel.pageSize);
  };

  const tableOptions = {
    rowHeight: 40,
    columnHeaderHeight: 45,
    paginationMode: "server",
    rowCount: totalRowsCount,
    paginationModel: {
      page: currentPage,
      pageSize: rowsPerPage,
    },
    onPaginationModelChange: handlePaginationModelChange,
    pageSizeOptions: [10, 20, 30],
    disableRowSelectionOnClick: true,
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    getRowId: (row) => row.id,
    localeText: {
      noRowsLabel: "",
      noResultsOverlayLabel: "",
      MuiTablePagination: {
        labelRowsPerPage: "Filas:",
        labelDisplayedRows: ({ from, to, count }) =>
          `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`,
      },
    },
    sx: {
      '& .MuiDataGrid-cell': {
        fontSize: '0.9em',
      },
      '& .MuiDataGrid-columnHeaders': {
        backgroundColor: '#f5f5f5',
      },
    },
  };
  //
  // ################################################################################
  // 
  useEffect(() => {
    loadArAsMarcas();
    loadArAsCategorias();
    loadArAsMateriales();
    loadArAsFormatos();
    loadArAsCalibres();
    loadArAsTipos();
    loadArAsColores();
  }, []);
  //
  // ################################################################################
  // 
  useEffect(() => {
    load();
  }, [currentPage, rowsPerPage]);
  //
  // ################################################################################
  //
  const handleChange = (e) => {
    setSearchData({
      ...searchData,
      [e.target.name]:
        e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const handleLimpiar = () => {
    setSearchData(initialSearchData);
    setItemsCrud([]);
    setValueACArAsMarca(null);
    setInputValueACArAsMarca("");
    setValueACArAsCategoria(null);
    setInputValueACArAsCategoria("");
    setValueACArAsMaterial(null);
    setInputValueACArAsMaterial("");
    setValueACArAsFormato(null);
    setInputValueACArAsFormato("");
    setValueACArAsCalibre(null);
    setInputValueACArAsCalibre("");
    setValueACArAsTipo(null);
    setInputValueACArAsTipo("");
    setValueACArAsColor([]);
    setInputValueACArAsColor("");
  };
  //
  // ################################################################################
  //
  const handleBuscar = () => {
    if (currentPage !== 0) {
      setCurrentPage(0);
    } else {
      load();
    }
  };
  //
  // ################################################################################
  //
  const load = async () => {

    setSearchData({
      ...searchData,
      codigo: limpiaCodigo(searchData.codigo).toUpperCase(),
      codigoExterno: limpiaCodigo(searchData.codigoExterno).toUpperCase()
    });

    let _params = {
      codigo: searchData.codigo,
      idArAsMarca: searchData.idArAsMarca,
      modelo: searchData.modelo,
      codigoExterno: searchData.codigoExterno,
      descripcion: searchData.descripcion,
      idArAsCategoria: searchData.idArAsCategoria,
      idArAsMaterial: searchData.idArAsMaterial,
      idArAsFormato: searchData.idArAsFormato,
      idArAsCalibre: searchData.idArAsCalibre,
      idArAsTipo: searchData.idArAsTipo,
      colorList: searchData.colorList,
      estado: searchData.estado,
      rows: rowsPerPage,
      first: currentPage * rowsPerPage,
    };

    setIsDoingSomething(true);
    const response = await getArmazones(_params);
    setIsDoingSomething(false);

    if (response.ok) {
      setTotalRowsCount(response.data.count);
      setItemsCrud(response.data.data);
    } else {
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const handleClickActionCrud = (parItem, parAction) => {
    if (parAction !== "new") {
      navigate("/articulo/armazon/" + parItem.id + "/" + parAction);
    } else {
      navigate("/articulo/armazon/new/" + parAction);
    }
  };
  //
  // ################################################################################
  // 
  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleBuscar();
    }
  };
  //
  // ################################################################################
  //
  const loadArAsMarcas = async () => {
    const response = await getCacheData("ar_as_marca")
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setArAsMarcas(_var);
    } else {
      setArAsMarcas([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadArAsCategorias = async () => {
    const response = await getCacheData("ar_as_categoria")
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setArAsCategorias(_var);
    } else {
      setArAsCategorias([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadArAsMateriales = async () => {
    const response = await getCacheData("ar_as_material")
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setArAsMateriales(_var);
    } else {
      setArAsMateriales([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadArAsFormatos = async () => {
    const response = await getCacheData("ar_as_formato")
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setArAsFormatos(_var);
    } else {
      setArAsFormatos([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadArAsCalibres = async () => {
    const response = await getCacheData("ar_as_calibre")
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: String(item.valor),
        });
      });
      setArAsCalibres(_var);
    } else {
      setArAsCalibres([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadArAsTipos = async () => {
    const response = await getCacheData("ar_as_tipo")
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setArAsTipos(_var);
    } else {
      setArAsTipos([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadArAsColores = async () => {
    const response = await getCacheData("ar_as_color");
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];

      // Agregar la opción "Todos"
      _var.push({
        id: 'all',
        label: 'Todos',
      });
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setArAsColores(_var);
    } else {
      setArAsColores([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Paper elevation={0} sx={{ mx: 0.5, maxWidth: "100%" }}>
        <Paper elevation={1} >
          <Box sx={{ mx: 1, px: 1, pb: 1 }}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Box sx={{ mt: 1 }} display="flex" justifyContent="space-between" alignItems="center">
                  <Typography variant="h5" display="cristal" gutterBottom >
                    {nameItemsText}
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="codigo"
                  label="Código"
                  variant="outlined"
                  size="small"
                  name="codigo"
                  value={searchData.codigo}
                  onChange={handleChange}
                  onKeyDown={handleKeyDown}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="descripcion"
                  label="Descripción"
                  variant="outlined"
                  size="small"
                  name="descripcion"
                  value={searchData.descripcion}
                  onChange={handleChange}
                  onKeyDown={handleKeyDown}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <Autocomplete
                  id="id-ar-as-marca"
                  size="small"
                  value={
                    valueACArAsMarca && valueACArAsMarca.id
                      ? valueACArAsMarca
                      : null
                  }
                  onChange={(event, newValue) => {
                    setValueACArAsMarca(newValue);
                    setSearchData({
                      ...searchData,
                      idArAsMarca: newValue ? newValue.id : "",
                    });
                  }}
                  inputValue={inputValueACArAsMarca}
                  onInputChange={(event, newInputValue) => {
                    setInputValueACArAsMarca(newInputValue);
                  }}
                  options={arAsMarcas}
                  getOptionLabel={(option) => option.label ? option.label : ""}
                  renderInput={(params) => <TextField {...params} label="Marca" />}
                  isOptionEqualToValue={(option, value) => {
                    if (!value || !value.id) return false;
                    return option.id === value.id;
                  }}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="modelo"
                  label="Modelo"
                  variant="outlined"
                  size="small"
                  name="modelo"
                  value={searchData.modelo}
                  onChange={handleChange}
                  onKeyDown={handleKeyDown}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <Autocomplete
                  id="id-ar-as-categoria"
                  size="small"
                  value={
                    valueACArAsCategoria && valueACArAsCategoria.id
                      ? valueACArAsCategoria
                      : null
                  }
                  onChange={(event, newValue) => {
                    setValueACArAsCategoria(newValue);
                    setSearchData({
                      ...searchData,
                      idArAsCategoria: newValue ? newValue.id : "",
                    });
                  }}
                  inputValue={inputValueACArAsCategoria}
                  onInputChange={(event, newInputValue) => {
                    setInputValueACArAsCategoria(newInputValue);
                  }}
                  options={arAsCategorias}
                  getOptionLabel={(option) => option.label ? option.label : ""}
                  renderInput={(params) => <TextField {...params} label="Categoría" />}
                  isOptionEqualToValue={(option, value) => {
                    if (!value || !value.id) return false;
                    return option.id === value.id;
                  }}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <Autocomplete
                  id="id-ar-as-material"
                  size="small"
                  value={
                    valueACArAsMaterial && valueACArAsMaterial.id
                      ? valueACArAsMaterial
                      : null
                  }
                  onChange={(event, newValue) => {
                    setValueACArAsMaterial(newValue);
                    setSearchData({
                      ...searchData,
                      idArAsMaterial: newValue ? newValue.id : "",
                    });
                  }}
                  inputValue={inputValueACArAsMaterial}
                  onInputChange={(event, newInputValue) => {
                    setInputValueACArAsMaterial(newInputValue);
                  }}
                  options={arAsMateriales}
                  getOptionLabel={(option) => option.label ? option.label : ""}
                  renderInput={(params) => <TextField {...params} label="Material" />}
                  isOptionEqualToValue={(option, value) => {
                    if (!value || !value.id) return false;
                    return option.id === value.id;
                  }}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <Autocomplete
                  id="id-ar-as-formato"
                  size="small"
                  value={
                    valueACArAsFormato && valueACArAsFormato.id
                      ? valueACArAsFormato
                      : null
                  }
                  onChange={(event, newValue) => {
                    setValueACArAsFormato(newValue);
                    setSearchData({
                      ...searchData,
                      idArAsFormato: newValue ? newValue.id : "",
                    });
                  }}
                  inputValue={inputValueACArAsFormato}
                  onInputChange={(event, newInputValue) => {
                    setInputValueACArAsFormato(newInputValue);
                  }}
                  options={arAsFormatos}
                  getOptionLabel={(option) => option.label ? option.label : ""}
                  renderInput={(params) => <TextField {...params} label="Formato" />}
                  isOptionEqualToValue={(option, value) => {
                    if (!value || !value.id) return false;
                    return option.id === value.id;
                  }}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <Autocomplete
                  id="id-ar-as-calibre"
                  size="small"
                  value={
                    valueACArAsCalibre && valueACArAsCalibre.id
                      ? valueACArAsCalibre
                      : null
                  }
                  onChange={(event, newValue) => {
                    setValueACArAsCalibre(newValue);
                    setSearchData({
                      ...searchData,
                      idArAsCalibre: newValue ? newValue.id : "",
                    });
                  }}
                  inputValue={inputValueACArAsCalibre}
                  onInputChange={(event, newInputValue) => {
                    setInputValueACArAsCalibre(newInputValue);
                  }}
                  options={arAsCalibres}
                  getOptionLabel={(option) => option.label}
                  renderInput={(params) => <TextField {...params} label="Calibre" />}
                  isOptionEqualToValue={(option, value) => {
                    if (!value || !value.id) return false;
                    return option.id === value.id;
                  }}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <Autocomplete
                  id="id-ar-as-tipo"
                  size="small"
                  value={
                    valueACArAsTipo && valueACArAsTipo.id
                      ? valueACArAsTipo
                      : null
                  }
                  onChange={(event, newValue) => {
                    setValueACArAsTipo(newValue);
                    setSearchData({
                      ...searchData,
                      idArAsTipo: newValue ? newValue.id : "",
                    });
                  }}
                  inputValue={inputValueACArAsTipo}
                  onInputChange={(event, newInputValue) => {
                    setInputValueACArAsTipo(newInputValue);
                  }}
                  options={arAsTipos}
                  getOptionLabel={(option) => option.label ? option.label : ""}
                  renderInput={(params) => <TextField {...params} label="Tipo" />}
                  isOptionEqualToValue={(option, value) => {
                    if (!value || !value.id) return false;
                    return option.id === value.id;
                  }}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <Autocomplete
                  id="id-ar-as-color"
                  size="small"
                  multiple
                  value={valueACArAsColor}
                  onChange={(event, newValue) => {
                    const isAllSelected = newValue.some((item) => item.id === 'all');
                    let finalValue;
                    if (isAllSelected) {
                      // Si ya estaban todos seleccionados y clickea "Todos", se desmarca todo
                      if (valueACArAsColor.length === arAsColores.length - 1) {
                        finalValue = [];
                      } else {
                        // Selecciona todos excepto "Todos"
                        finalValue = arAsColores.filter((item) => item.id !== 'all');
                      }
                    } else {
                      finalValue = newValue;
                    }
                    setValueACArAsColor(finalValue);
                    setSearchData({
                      ...searchData,
                      colorList: finalValue.map((item) => item.id),
                    });
                  }}
                  inputValue={inputValueACArAsColor}
                  onInputChange={(event, newInputValue) => {
                    setInputValueACArAsColor(newInputValue);
                  }}
                  options={arAsColores}
                  getOptionLabel={(option) => option.label || ""}
                  isOptionEqualToValue={(option, value) => option.id === value.id}
                  renderTags={(value, getTagProps) => {
                    if (value.length === arAsColores.length - 1) {
                      return <Chip label="Todos seleccionados" />;
                    }
                    if (value.length > 2) {
                      return <Chip label={`${value.length} colores seleccionados`} />;
                    }
                    return value.map((option, index) => (
                      <Chip
                        key={option.id}
                        label={option.label}
                        {...getTagProps({ index })}
                      />
                    ));
                  }}
                  renderInput={(params) => <TextField {...params} label="Color" />}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="codigoExterno"
                  label="Código Externo"
                  variant="outlined"
                  size="small"
                  name="codigoExterno"
                  value={searchData.codigoExterno}
                  onChange={handleChange}
                  onKeyDown={handleKeyDown}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <FormControl sx={{ width: "100%" }}>
                  <InputLabel id="id-estado">
                    Estado
                  </InputLabel>
                  <Select
                    sx={{ width: "100%", mr: 1 }}
                    labelId="estado"
                    label="Estado"
                    id="estado"
                    name="estado"
                    value={searchData.estado}
                    size="small"
                    onChange={handleChange}
                  >
                    {estadoOptions.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.descripcion}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Box>

          <Box sx={{ mx: 1, mb: 1, px: 1, pb: 1 }}>
            <Grid container spacing={1}>

              {_crearArmazon && (
                <Grid item xs={12} md={12} lg={1}>
                  <Box sx={{ display: "flex", gap: 1 }}>
                    <Tooltip title="crear nuevo armazon">
                      <Button
                        fullWidth
                        className="btn-add"
                        variant="contained"
                        size="small"
                        onClick={() => handleClickActionCrud({}, "new")}
                        startIcon={<Add />}
                      >
                        Nuevo
                      </Button>
                    </Tooltip>
                  </Box>
                </Grid>
              )}

              <Grid item xs={12} md={12} lg={1}>
                <Box sx={{ display: "flex", gap: 1 }}>
                  <Tooltip title="buscar">
                    <Button
                      fullWidth
                      variant="contained"
                      size="small"
                      onClick={handleBuscar}
                      startIcon={<SearchIcon />}
                    >
                      Buscar
                    </Button>
                  </Tooltip>
                </Box>
              </Grid>

              <Grid item xs={12} md={12} lg={1}>
                <Box sx={{ display: "flex", gap: 1 }}>
                  <Tooltip title="limpiar filtros">
                    <Button
                      fullWidth
                      variant="outlined"
                      size="small"
                      onClick={handleLimpiar}
                      startIcon={<CleaningServicesIcon />}
                    >
                      Limpiar
                    </Button>
                  </Tooltip>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Paper>

        <DataGrid
          rows={itemsCrud}
          columns={tableColumns}
          {...tableOptions}
        />
      </Paper>

      {showMessage && (
        <Message
          showMessage={showMessage}
          setShowMessage={setShowMessage}
          message={message}
        />
      )}

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default ArmazonTable;
